import { restClient } from 'config/store/configureStore';

import { TVA_VALUES_URL } from 'constants/ApiConstants';

export default {
  getTvaValues: () => restClient.get(`${TVA_VALUES_URL}`),
};
